import EmailContext from '@Editor/EmailContext';
import { useContext } from 'react';

const useEmailEditor = () => useContext(EmailContext);

export default useEmailEditor;
